import { render, staticRenderFns } from "./MessagesOwn.vue?vue&type=template&id=02d68eec&"
import script from "./MessagesOwn.vue?vue&type=script&lang=js&"
export * from "./MessagesOwn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports